import Trinity from '@core/scripts/components/trinity-adapter.js';

const SCHEMAS = Object.freeze({
    CLICK_FOOTER_BOTTOMLINKS: {name: 'CLICK_FOOTER_BOTTOMLINKS', version: 6},
    PAGE_WITHDRAWAL: {name: 'PAGE_WITHDRAWAL', version: 2},
    CLICK_WITHDRAW_CONTRACT: {name: 'CLICK_WITHDRAW_CONTRACT', version: 1},
    VIEW_WITHDRAW_RESULT: {name: 'VIEW_WITHDRAW_RESULT', version: 1},
    CLICK_WITHDRAW_RESULT: {name: 'CLICK_WITHDRAW_RESULT', version: 1},
    ERRORVIEW_WITHDRAW_CONTRACT: {name: 'ERRORVIEW_WITHDRAW_CONTRACT', version: 1},
});

interface ClickEventAttributes {
    object: string;
    clickName: ClickName;
}

interface SubmitSuccessAttributes {
    responseMessage: string;
}

interface PageEventAttributes {
    name: string;
    type: string;
}

interface ErrorViewAttributes {
    errorCode: string;
    errorMessage?: string;
}

export type WITHDRAWAL_STATUS = 'success' | 'failure';

export type WITHDRAWAL_SUCCESS_REASON = 'fullCancellation' | 'fullReturn' | 'mixedAction';

export type WITHDRAWAL_FAILURE_REASON =
    'invalidCredentials' | 'alreadyRegistered' | 'alreadyCancelled' | 'periodExpired';

export type WITHDRAWAL_REASON = WITHDRAWAL_SUCCESS_REASON | WITHDRAWAL_FAILURE_REASON;

interface ViewWithdrawResult {
    viewName: string;
    status: WITHDRAWAL_STATUS;
    reason: WITHDRAWAL_REASON;
}

const enum ClickName {
    WITHDRAW_CONTRACT = 'withdrawContract',
    ABORT_WITHDRAWAL = 'abortWithdrawal',
    CONFIRM_WITHDRAWAL = 'confirmWithdrawal',
    CUSTOMER_SUPPORT_LINK = 'customerSupportLink',
    BACK_TO_HOMEPAGE = 'backToHomepage',
    GO_TO_MY_ACCOUNT = 'goToMyAccount',
}

const enum ClickObject {
    BUTTON = 'button',
    LINK = 'link',
}

const enum ViewName {
    WITHDRAWAL_RESULT_PAGE = 'withdrawalResultPage',
}

const trackEvent = (
    schema: keyof typeof SCHEMAS,
    attributes:
        ClickEventAttributes | SubmitSuccessAttributes | ErrorViewAttributes | PageEventAttributes | ViewWithdrawResult,
) => {
    Trinity.sendTrinityEvent({
        schema: {
            version: SCHEMAS[schema].version,
            name: SCHEMAS[schema].name,
        },
        attributes,
    });
};

const WithdrawalTracking = {
    trackClickWithdrawContract: () => {
        trackEvent('CLICK_WITHDRAW_CONTRACT', {
            clickName: ClickName.CONFIRM_WITHDRAWAL,
            object: ClickObject.BUTTON,
        });
    },

    trackClickAbortWithdraw: () => {
        trackEvent('CLICK_WITHDRAW_CONTRACT', {
            clickName: ClickName.ABORT_WITHDRAWAL,
            object: ClickObject.BUTTON,
        });
    },

    trackClickWithdrawCustomerSupport: () => {
        trackEvent('CLICK_WITHDRAW_CONTRACT', {
            clickName: ClickName.CUSTOMER_SUPPORT_LINK,
            object: ClickObject.LINK,
        });
    },

    trackClickGoToMyAccount() {
        trackEvent('CLICK_WITHDRAW_RESULT', {
            clickName: ClickName.GO_TO_MY_ACCOUNT,
            object: ClickObject.LINK,
        });
    },

    trackViewWithdrawResult: (status: WITHDRAWAL_STATUS, reason: WITHDRAWAL_REASON) => {
        const attributes: ViewWithdrawResult = {
            viewName: ViewName.WITHDRAWAL_RESULT_PAGE,
            status,
            reason,
        };
        trackEvent('VIEW_WITHDRAW_RESULT', attributes);
    },

    trackClickBackToHome() {
        trackEvent('CLICK_WITHDRAW_RESULT', {
            clickName: ClickName.BACK_TO_HOMEPAGE,
            object: ClickObject.LINK,
        });
    },

    trackErrorView: (errorCode: string, errorMessage?: string) => {
        trackEvent('ERRORVIEW_WITHDRAW_CONTRACT', {
            errorMessage,
            errorCode,
        });
    },
};

export default WithdrawalTracking;
